import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const CheckIcon: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M10.8032 2.17664L4.63691 9.88449L1.03992 6.80135" stroke="" strokeWidth="2.05543" />
    </svg>
  );
};

export { CheckIcon };
